import React, { useState, useEffect } from 'react';
import Text from 'ui/Text';
import { PROFILE_KEY } from 'utils/app-constants';
import localStorage from 'utils/localStorage';
import axios from 'utils/axios';
import { get } from 'lodash';
import { FormattedMessage } from 'react-intl';

const Profile = () => {
  const profile = JSON.parse(localStorage.getItem(PROFILE_KEY));
  const [countries, setCountries] = useState([]);

  const fetchCountrries = () => {
    axios.get('/country').then(res => {
      setCountries(get(res, 'data'));
    });
  };

  useEffect(() => {
    fetchCountrries();
  }, []);

  const country =
    countries &&
    countries.filter(country => {
      if (get(profile, 'user.country_code') === country.Code) {
        return country;
      }
    });

  return (
    <div className="intro-banner profile-section">
      <div className="name-card col-4">
        <span className="name">
          <FormattedMessage id="Profile.Organisation" defaultMessage={`Organisation`} />
        </span>
        <Text type="normal-bold">{get(profile, 'user.organisation')}</Text>
      </div>
      <div className="details-card col-8">
        <span className="name">
          <FormattedMessage id="Profile.Contact" defaultMessage={`Contact`} />
        </span>
        <span className="name">
          <FormattedMessage id="Profile.Country" defaultMessage={`Country`} />
        </span>
        <Text type="normal-bold">{get(profile, 'user.names')}</Text>
        <Text type="normal-bold">{get(country, '[0]Name')}</Text>

        <span className="name">
          <FormattedMessage id="Form.EmailAddress" defaultMessage={`Email`} />
        </span>
        <span className="name">
          <FormattedMessage id="Profile.Language" defaultMessage={`Language`} />
        </span>
        <Text type="normal-bold">{get(profile, 'user.email')}</Text>
        <Text type="normal-bold">
          {get(profile, 'user.locale') === 'en_US' ? 'English' : 'French'}
        </Text>
      </div>
    </div>
  );
};

export default Profile;



// WEBPACK FOOTER //
// ./src/components/CDRSections/Profile.js